import React, { useState } from 'react';
import { translations, COLORS } from '@/components/landing/landingData';
import '@/components/landing/landing.css';
import { Navbar } from '@/components/landing/Navbar';
import { HeroSection } from '@/components/landing/HeroSection';
import { ShowcaseSection } from '@/components/landing/ShowcaseSection';
import { EcosystemSection } from '@/components/landing/EcosystemSection';
import { OfflineDemo } from '@/components/landing/OfflineDemo';
import { VideoSection } from '@/components/landing/VideoSection';
import { CtaFooter } from '@/components/landing/CtaFooter';

export default function LandingPage() {
  const [lang, setLang] = useState('en');
  const t = translations[lang];
  const [activeEco, setActiveEco] = useState('dist');
  const [offlineDemo, setOfflineDemo] = useState(true);

  return (
    <div style={{ background: COLORS.bg, fontFamily: 'Manrope, sans-serif', color: COLORS.text, minHeight: '100vh' }}>
      <Navbar lang={lang} setLang={setLang} t={t} />
      <HeroSection t={t} />
      <ShowcaseSection lang={lang} />
      <VideoSection lang={lang} />
      <EcosystemSection lang={lang} activeEco={activeEco} setActiveEco={setActiveEco} />
      <OfflineDemo t={t} offlineDemo={offlineDemo} setOfflineDemo={setOfflineDemo} />
      <CtaFooter t={t} />
    </div>
  );
}
